import { render, staticRenderFns } from "./Outbox.vue?vue&type=template&id=cfc7c208&scoped=true"
import script from "./Outbox.vue?vue&type=script&lang=js"
export * from "./Outbox.vue?vue&type=script&lang=js"
import style0 from "./Outbox.vue?vue&type=style&index=0&id=cfc7c208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc7c208",
  null
  
)

export default component.exports